import { useEffect } from 'react';
import { useRunTimeEnvironment } from '../utils/hooks';
import { useLocation, useNavigate } from 'react-router';

// 디바이스 체크 애플리케이션 래퍼 컴포넌트
const DeviceCheck = ({ children }) => {
  const RTE = useRunTimeEnvironment();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    // PC 접근을 허용할 경로 목록
    const EXEMPTED_PATHS = ['/desktop-only', '/temp'];

    // 현재 경로가 예외 경로인지 확인
    const isExemptedPath = EXEMPTED_PATHS.some((path) => location.pathname.startsWith(path));

    // App 환경이 아닌 경우에 PC 전용 페이지로 리다이렉트
    if (RTE !== 'APP' && !isExemptedPath) {
      navigate('/desktop-only', { replace: true, state: { from: location } });
    }
  }, [RTE, location, navigate]);

  return children;
};

export default DeviceCheck;
